import React, { useContext } from "react";

import notSearchedImg from "../../../../assets/images/Curly Arrow.svg";

import { H3, P } from "../../../atoms/Texts";

import { useParams } from "react-router";
import { PrimaryButton } from "../../../atoms/Buttons";
import ActionPageHero from "../../../molecules/ActionPageHero";
import { Link } from "react-router-dom";
import { EligibilityTable } from "../../../organisms/EligibilityTable";
import { demoContext } from "../../../../shared/store/contexts";

const AllEligibilityCriteriaPage = () => {
  const { id } = useParams();

  const { eligibilities, services } = useContext(demoContext);

  return (
    <main className="flex flex-col w-full">
      <div className="flex justify-between items-center">
        <ActionPageHero
          className="organization-container"
          title="Eligibility"
          action
          actionComponent={
            <Link to={`/dashboard/organization/${id}/eligibility/add`}>
              <PrimaryButton>Add Eligibility hello</PrimaryButton>
            </Link>
          }
          description="Add the criteria required to screen referrals"
        />
      </div>
      <section className="organization-container pb-10 flex-grow flex flex-col mt-6">
        {eligibilities.length > 0 ? (
          <div className="bg-white shadow-md w-full h-full">
            <EligibilityTable eligibilities={eligibilities} services={services} />
          </div>
        ) : (
          <>
            <div className="flex justify-center items-center flex-grow">
              <div className="flex flex-col items-center flex-grow justify-center">
                <img src={notSearchedImg} alt="" className="" />
                <H3 color="#22202D" className="mt-6" data-testid="eligibility-text">
                  No eligibility criteria added yet
                </H3>
                <P
                  fontSize="16px"
                  color="#7D7B96"
                  className="mt-3 mb-0 text-center w-1/3"
                >
                  Search through your database of eligibility criteria or add new
                  criteria.
                </P>
              </div>
            </div>
          </>
        )}
      </section>
    </main>
  );
};

export default AllEligibilityCriteriaPage;
